<script>
  import { flip } from "svelte/animate";
  import { dndzone } from "svelte-dnd-action";
  import {
    getEncounterDischargeDateWithFallBackDuration,
    getText,
    showError,
    _getName,
    showInfo,
    getTime,
  } from "../../../Utils/utilFunctions.svelte";

  import { apiMethods } from "../../../Services/index.svelte";

  import { cloneDeep } from "lodash";

  import { createEventDispatcher, onDestroy, onMount } from "svelte";
  import {
    getEncounterAdjustScheduledDate,
    openViewEncounterSidePanel,
  } from "../../PatientEncounter/helpers/encounterHelper.svelte";

  import BasicInfo from "../../../Components/Custom/Table/Components/EncounterTable/BasicInfo.svelte";
  import InsuranceValidationInfo from "../../../Components/Custom/Table/Components/EncounterTable/InsuranceValidationInfo.svelte";
  import EncounterStatusInfo from "../../../Components/Custom/Table/Components/EncounterTable/EncounterStatusInfo.svelte";
  import TableActions from "../../../Components/Custom/Table/Components/EncounterTable/TableActions.svelte";
  import BillingStatusInfo from "../../../Components/Custom/Table/Components/EncounterTable/BillingStatusInfo.svelte";

  import { DirectEncounterStatus } from "../../../Utils/utilEnums.svelte";

  export let items = [],
    selectedEvent = {},
    handleEditNestedEncounter = () => {},
    reloadReOpenCurrentEvent = async () => {},
    refreshNestedEncounters = async () => {},
    selectedEncounterIdForNotes;


  const flipDurationMs = 50,
    dispatch = createEventDispatcher();

  let dragDisabled = false,
    encountersRearranged = false,
    isRearrangingEncounters = false,
    originalEncounters = [];

  let titleRow, rowContainer;

  let basicInfoRefs = {},
    tableActionRefs = {};

  const init = () => {
    originalEncounters = cloneDeep(items);
    dragDisabled = !items || !items.length || items.length <= 1;
    encountersRearranged = false;
  };

  onMount(() => {
    if (selectedEncounterIdForNotes) {
      const tableActionComponent = tableActionRefs[selectedEncounterIdForNotes];
      if (tableActionComponent) tableActionComponent._openViewNotesModal();
    }
  });

  onDestroy(() => {
    if (encountersRearranged) dispatch("reload");
  });

  function handleDndConsider(e) {
    items = e.detail.items;
  }
  function handleDndFinalize(e) {
    items = e.detail.items;
    handleEncountersOrderChange();
  }

  const handleEncountersOrderChange = async () => {
    const originalOrder = originalEncounters.map((i) => i.id);
    const newOrder = items.map((i) => i.id);

    // return if no change made;
    if (originalOrder.join() == newOrder.join()) return;

    dragDisabled = true;
    isRearrangingEncounters = true;
    const promises = [];

    // start rearranging from change index
    const changeIndex = originalOrder.findIndex((val, i) => val != newOrder[i]);

    for (let i = changeIndex; i < items.length; i++) {
      if (i == changeIndex)
        items[i].scheduledDate = originalEncounters[i].scheduledDate;
      else
        items[i].scheduledDate = getEncounterAdjustScheduledDate(
          items[i],
          items[i - 1],
          selectedEvent.toDate,
        );

      items[i].dischargeDate = getEncounterDischargeDateWithFallBackDuration(
        items[i],
      );

      const originalEncounter = originalEncounters.find(
        (encounter) => encounter.id == items[i].id,
      );
      const hasTimeUpdated =
        originalEncounter.scheduledDate != items[i].scheduledDate ||
        originalEncounter.dischargeDate != items[i].dischargeDate;

      hasTimeUpdated &&
        promises.push(
          apiMethods.putMethod
            .updateEncounterScheduleDate(items[i].id, {
              scheduledDate: items[i].scheduledDate,
              dischargeDate: items[i].dischargeDate,
            })
            .catch(() =>
              showError(
                "Failed to update time for encounter " + insertEncounter.id,
              ),
            ),
        );
    }

    await Promise.all(promises);

    showInfo("Encounter times rearranged");
    encountersRearranged = true;

    const reEnableDragDelayMS = 200;
    setTimeout(() => {
      originalEncounters = cloneDeep(items);
      dragDisabled = false;
      isRearrangingEncounters = false;
      items.forEach((item) => {
        const basicInfoComponent = basicInfoRefs[item.id];
        if (basicInfoComponent) basicInfoComponent.checkIfTruncated();
      });
    }, reEnableDragDelayMS);
  };

  const encounterClick = (e, encounter) => {
    // openViewEncounterNewPage(encounter.id);
    openViewEncounterSidePanel({
      encounterId: encounter.id,
      onCloseFunction: () => {
        refreshNestedEncounters();

        items.forEach((item) => {
          const basicInfoComponent = basicInfoRefs[item.id];
          if (basicInfoComponent)
            basicInfoComponent.resetLoadPatientContactInfo();
        });
      },
    });
  };

  const syncTitleScroll = () => {
    if (titleRow && rowContainer) titleRow.scrollLeft = rowContainer.scrollLeft;
  };
  
</script>

<div
  class="w-full grid grid-col gap-x-2 border-b-2 border-[#818e9b] p-2 relative overflow-hidden"
  use:init
  bind:this={titleRow}
>
  <span class={`w-full mx-auto text-left col-span-1`}>Patient</span>
  <span class={`w-full mx-auto text-left col-span-1`}></span>
  <span class={`w-full mx-auto text-left col-span-1`}> Id</span>
  <span class={`w-full mx-auto text-left col-span-1 pl-4`}> Insurance</span>
  <span class={`w-full mx-auto text-left col-span-1 pl-4`}> Status</span>
  <span class={`w-full mx-auto text-left col-span-1 pl-4`}>Billing Status</span>
  <span class={`w-full mx-auto text-left col-span-1`}> </span>
  <span class={`w-full mx-auto text-left col-span-1`}> Est Time </span>
  <span class={`w-full mx-auto text-left col-span-1`}> </span>
  <span class={`w-full mx-auto text-left col-span-1`}> </span>
</div>

<section
  class="w-full h-full overflow-auto"
  bind:this={rowContainer}
  use:dndzone={{ items, flipDurationMs, dragDisabled }}
  on:consider={handleDndConsider}
  on:finalize={handleDndFinalize}
  on:scroll={syncTitleScroll}
>
  {#each items as item (item.id)}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
      class="w-full grid grid-col gap-x-2 p-2 items-end encounterClass cursor-pointer hover:bg-gray-100 text-sm {item.status ==
      DirectEncounterStatus.Cancelled
        ? 'bg-[#E3E3E3]'
        : ''}"
      animate:flip={{ duration: flipDurationMs }}
      on:click={(e) => encounterClick(e, item)}
    >
      <!-- Encounter & Patient Basic Info  -->
      <span class={`w-full mx-auto text-left col-span-1`}>
        <BasicInfo
          bind:this={basicInfoRefs[item.id]}
          row={item}
          hideAlertIcon
          hideIcons
        />
      </span>

      <!-- AlertIcon -->
      <span class={`w-full mx-auto text-left col-span-1 hover:z-[10]`}>
        <BasicInfo row={item} hideInfo hideIcons />
      </span>

      <!-- Encounter ID -->
      <span
        class={`flex flex-1 items-center h-full w-full mx-auto text-left col-span-1`}
      >
        {getText(item.id)}
      </span>

      <!-- Insurance Details -->
      <span
        class={`flex flex-1 items-center h-full w-full mx-auto text-left col-span-1 hover:z-[10]`}
      >
        <InsuranceValidationInfo row={item} />
      </span>

      <!-- Encounter Status -->
      <span
        class={`flex flex-1 items-center h-full w-full mx-auto text-left col-span-1`}
        on:click={(e) => e.stopPropagation()}
      >
        <EncounterStatusInfo
          row={item}
          onStatusChange={reloadReOpenCurrentEvent}
        />
      </span>

      <!-- Billing Status -->
      <span
        class={`flex flex-1 items-center h-full w-full mx-auto text-left col-span-1`}
      >
        <BillingStatusInfo row={item} />
      </span>

      <!-- Survey Icons -->
      <span
        class={`flex flex-1 items-center h-full w-full mx-auto text-left col-span-1 hover:z-[10]`}
      >
        <BasicInfo row={item} hideInfo hideAlertIcon />
      </span>

      <!-- Est. Time -->
      <span
        class={`flex flex-1 items-center h-full w-full mx-auto text-left col-span-1`}
      >
        {getTime(item.scheduledDate)}
      </span>

      <!-- Actions -->
      <div
        class={`flex flex-1 items-center justify-end h-full w-full mx-auto text-left col-span-1`}
        on:click={(e) => e.stopPropagation()}
      >
        <TableActions
          row={item}
          actionIconOpenNewTab
          isFromCalendarList
          afterModifyNotes={() => refreshNestedEncounters()}
          bind:this={tableActionRefs[item.id]}
        />
      </div>

      <!-- Empty span -->
      <span
        class={`flex flex-1 items-center h-full w-full mx-auto text-left col-span-1`}
      >
      </span>
    </div>
  {/each}
</section>

<style>
  .grid-col {
    grid-template-columns:
      15rem 2.5rem 5rem 9rem 11rem
      repeat(2, 9rem) 5rem minmax(15rem, 1fr) 1rem;
  }

  .encounterClass + .encounterClass {
    border-top: 1px solid #818e9b;
  }
</style>
